import { proxy } from 'valtio';
import { z } from 'zod';

export const stateSchema = z.object({
  devtoolsEnabled: z.boolean(),
});

export type State = z.infer<typeof stateSchema>;

const state = proxy<State>({
  devtoolsEnabled: false,
});

/** Toggles the devtoolsEnabled state */
export function toggleDevtools() {
  state.devtoolsEnabled = !state.devtoolsEnabled;
}

Object.defineProperty(window, 'devtoolsEnabled', {
  get: () => state.devtoolsEnabled,
  set: (value) => {
    state.devtoolsEnabled = value;
  },
});

window.toggleDevtools = toggleDevtools;

export default state;
